import styled from '@emotion/styled';
import { Text, ButtonWithIcon } from '@blueprint/ui';
import { css } from '@emotion/react';
import { FiltersLabel } from '../../../search/FiltersModal/Filters.styles';
import { DropdownWithLabel } from '@blueprint/dropdown';
import { Radio } from '@blueprint/ui';

const MOBILE_SECTION_HEADLINE_MARGIN_BOTTOM = '12px';
const MOBILE_SECTION_RADIO_TOP = '2px';

export const StyledDropdown = styled.select(
    ({ theme: { colors, fontWeight } }) => css`
        border: 0;
        color: ${colors['primary-brand']};
        font-weight: ${fontWeight['bold']};
        font-size: 1rem;
        -webkit-appearance: none;
        -moz-appearance: none;
        text-indent: 1px;
        text-overflow: '';
        font-family: 'Lato', sans-serif;
        text-align-last: right;
        background-color: ${colors.white};
    `
);

type StyledButtonProps = {
    isDisabled?: boolean;
};

export const UpdateButtonWithIcon = styled(ButtonWithIcon)<StyledButtonProps>(
    (props) => {
        const {
            isDisabled = false,
            theme: { colors, spacing }
        } = props;
        return css`
            opacity: ${isDisabled ? 0.4 : 1};
            cursor: ${isDisabled ? 'default' : 'pointer'};
            box-shadow: 0px 0.3rem 0.7rem ${colors['neutral-3']};
            line-height: ${spacing['24px']};
            border: none;
        `;
    }
);

export const StyledLabel = styled(Text)(css``);

export const Wrapper = styled.div(
    ({ theme: { spacing } }) => css`
        display: flex;
        justify-content: space-between;
        padding: ${spacing['16px']} 0;
    `
);

export const FilterWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        margin: 0;
        width: 100%;
        padding-bottom: ${spacing['16px']};
    `
);

export const MobileSectionHeadline = styled(Text)(
    ({ theme: { fontSizes, fontWeight } }) => css`
        font-weight: ${fontWeight['bold']};
        display: flex;
        align-self: flex-start;
        font-size: ${fontSizes['1']};
        font-weight: 600;
        line-height: ${fontSizes['2']};
        margin-bottom: ${MOBILE_SECTION_HEADLINE_MARGIN_BOTTOM};
    `
);

export const LocationFilterWrapper = styled(FilterWrapper)(
    ({ theme: { spacing, fontSizes } }) => {
        return css`
            margin-top: ${spacing['16px']};
            padding-bottom: ${spacing['16px']};
            z-index: 4;
            line-height: ${fontSizes['7']};

            input {
                height: 56px;
            }

            input::placeholder {
                font-weight: 400;
                line-height: ${fontSizes['7']};
            }

            p {
                line-height: ${fontSizes['2']};
            }
        `;
    }
);

export const PropertyTypeRadio = styled.div(
    () => css`
        width: 50%;
        z-index: 0;
    `
);

export const StyledFiltersModal = styled.div(
    ({ theme: { spacing } }) => css`
        padding: ${spacing['16px']};
    `
);

export const RadiusDropdownWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        margin-top: ${spacing['24px']};
    `
);

export const SelectedPropertyTypeWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        margin-bottom: ${spacing['24px']};
    `
);

export const PriceFrequencyWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        width: 100%;
        margin-bottom: ${spacing['16px']};
    `
);

export const PropertyTypeFilterLabel = styled(FiltersLabel)(
    ({ theme: { fontSizes } }) => css`
        margin-top: 0;
        font-size: ${fontSizes['1']};
        font-weight: 600;
        line-height: ${fontSizes['2']};
        padding-bottom: ${MOBILE_SECTION_HEADLINE_MARGIN_BOTTOM};
    `
);

export const StyledDropdownWithLabel = styled(DropdownWithLabel)(
    ({ theme: { fontSizes } }) => css`
        line-height: ${fontSizes['7']};
        font-weight: 600;
        height: 56px;

        + p {
            font-weight: bold;
            line-height: ${fontSizes['2']};
        }
    `
);

export const StyledRadio = styled(Radio)(
    ({ theme: { fontSizes } }) => css`
        line-height: ${fontSizes['7']};
        top: ${MOBILE_SECTION_RADIO_TOP};

        + label {
            line-height: ${fontSizes['7']};
            font-weight: 400;
        }

        + label::before {
            top: ${MOBILE_SECTION_RADIO_TOP};
        }

        :focus + label::after {
            top: ${MOBILE_SECTION_RADIO_TOP};
        }
    `
);
